<ng-container *ngIf="data && !exportType">
   <div class="row">
    <!-- Filter items -->
    <div class="col-4 filter-container">
      <input type="text" class="form-control" [(ngModel)]="filterText" placeholder="Filter items..." />
    </div>
    <!-- Title -->
    <div class="col-4">
      <div class="page-title">BOM</div>
    </div>
    <!-- Buton menu -->
    <div class="col-4 table-buttons align-item-end" *ngIf="sortedCategories">
      <div class="d-flex flex-nowrap">
        <div class="d-flex">

          <button
          class="btn rounded-circle btn-bom"
          (click)="navigateToRfpList()"
          ngbTooltip="Request for Proposal"
        >
        <img src="assets/img/file-earmark-text.svg" alt="Offer" style="width: 20px; height: 20px;" />
      </button>
      <div class="btn-group-divider"></div>

          <button
          class="btn rounded-circle btn-bom"
          [ngbTooltip]="data.cdFileUrl ? 'Construction Documents' : 'Construction Documents Unavailable'"
          (click)="ToFileExplorer('CD')"
          [ngClass]="{'btn-document-unavailable': !data.cdFileUrl}"
        >
          <div class="icon icon-cd"></div>
        </button>


        <button class="btn rounded-circle btn-bom"
          [ngbTooltip]="data.sdFileUrl ? 'Shop Drawings' : 'Shop Drawings Unavailable'"
          (click)="ToFileExplorer('SD')"
          [ngClass]="{'btn-document-unavailable': !data.sdFileUrl}">
          <div class="icon icon-sd"></div>
        </button>

        <div class="btn-group-divider">


        </div>

        </div>

        <div class="d-flex flex-nowrap visible-md">
          <div
            class=""
            container="body"
            ngbDropdown
            #dropdownExcel="ngbDropdown"
          >
          <button
              ngbDropdownToggle
              class="btn rounded-circle btn-bom"
              ngbTooltip="Export to XLS"
            >
              <div class="icon icon-excel"></div>
            </button>
            <div ngbDropdownMenu style="padding: 8px">
              <app-export-list
                (export)="exportTo('excel', $event); dropdownExcel.close()"
                [defaultSelectAll]="true"
                [items]="sortedCategories"
              />
            </div>
          </div>
          <div class="" container="body" ngbDropdown #dropdownPdf="ngbDropdown">
            <button
              ngbDropdownToggle
              class="btn rounded-circle btn-bom"
              ngbTooltip="Export to PDF"
            >
              <div class="icon icon-pdf"></div>
            </button>
            <div ngbDropdownMenu style="padding: 8px">
              <app-export-list
                (export)="exportTo('pdf', $event); dropdownPdf.close()"
                [defaultSelectAll]="true"
                [items]="sortedCategories"
              />
            </div>
          </div>
          <div class="btn-group-divider"></div>

        <button
          class="btn rounded-circle btn-bom"
          (click)="show3DView()"
          ngbTooltip="3D Viewer"
        >
          <div class="icon icon-3dView"></div>
        </button>

        <button
          *ngIf="hasQuotesPermission()"
          class="btn rounded-circle btn-bom"
          (click)="createNewCommercialOffer()"
          ngbTooltip="Create Quote"
        >
          <img src="assets/img/file-earmark-text.svg" alt="Offer" style="width: 20px; height: 20px;" />
        </button>

        <div class="btn-group-divider"></div>

        <button
          class="btn btn-out "
          (click)="compareWithPrevious()"
          ngbTooltip="Compare with Previous Version"
          *ngIf="canShowComparisonButton()"
        >
          <i class="bi bi-arrow-left-right"></i>
        </button>
      </div>
        </div>



    </div>

  </div>

  <!-- Button scroll tabs -->
  <div class="row">
    <div class="col">
      <app-button-scroll-tabs
        class="w-100"
        *ngIf="tabs"
        [tabs]="tabs"
      ></app-button-scroll-tabs>
    </div>
  </div>

  <!-- Bom table -->
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="table-container" #tableContainer>
        <table class="table table-borderless bom-table m-0">
          <thead class="table-header" >
            <tr >
              <!-- Existing columns -->
              <th scope="col" class="">#</th>
              <th scope="col" class="">Item</th>
              <th scope="col" class="">Size</th>
              <th scope="col" class="">Description</th>
              <th scope="col" class="">Manufacturer</th>
              <th scope="col" class="">Model</th>
              <th scope="col" class="">Quantity</th>
              <th scope="col" class="">Waste Factor</th>
              <th scope="col"  class="">Quantity to Order</th>
              <th scope="col" *ngIf="data?.hasPrice">Unit price</th>
              <th scope="col" *ngIf="data?.hasPrice">Total price</th>
              <th scope="col"> </th>
              <th scope="col"> </th>

            </tr>
          </thead>
          <tbody class="table-body">
            <ng-container
              *ngFor="let grouppedSubcategory of filteredGroupedSubCategories ?? [] ; trackBy: trackByGroupedSubcategory"
            >
              <tr
                class="content-caption"
                *ngIf="grouppedSubcategory.name?.toLowerCase() !== 'default'"
              >
                <th scope="row" colspan="16" class="text-center caption">
                  {{ grouppedSubcategory.name | titlecase }}
                </th>
              </tr>
              <ng-container
                *ngFor="
                  let subcategory of grouppedSubcategory?.bgSubCategories ?? [];
                "
              >
                {{resetDuplicates()}}
                <tr
                  class="content-header"
                  [ngClass]="
                    subcategory.name.toLowerCase().startsWith('total')
                      ? 'total-row-header'
                      : ''
                  "
                >
                  <th scope="row" colspan="16" class="caption">
                    {{ subcategory.name | titlecase }}
                  </th>
                </tr>
                <tr
                  [ngClass]="{
                    'total-row-even':
                      subcategory.name.toLowerCase().startsWith('total') &&
                      index % 2 === 0,
                    'total-row-odd':
                      subcategory.name.toLowerCase().startsWith('total') &&
                      index % 2 === 1,
                    'custom-row-even': isBomTypeAddon(rowData) && index % 2 === 0,
                    'custom-row-odd': isBomTypeAddon(rowData)  && index % 2 === 1
                  }"
                  class="content align-middle"
                  *ngFor="
                    let rowData of (subcategory.bgBomItems );
                    let index = index
                  "
                >
                  <ng-container *ngIf="!rowData.isEditMode">
                    <td class="hidden-mobile text-center" scope="row">
                      <ng-container *ngIf="!rowData.showLoader">{{
                        rowData.flatIndex
                      }}</ng-container>
                    </td>
                    <td data-title="Item">
                      <span
                        class="text"
                        [ngClass]="{
                          duplicate: isFraming()
                            ? isDuplicate(rowData, 'itemName', true)
                            : false
                        }"
                        >{{ rowData.itemName }}</span
                      >
                    </td>

                    <td data-title="Size">
                      <div class="d-flex align-items-center">
                        <span class="text">{{ rowData.size }}</span>
                        <span *ngIf="isGypsumBoard(rowData)" class="text">{{ " x " }}</span>
                        <select *ngIf="isGypsumBoard(rowData)"
                          class="form-select"
                          (change)="onGypsumSizeDropdownChange(rowData, $event)"
                          [value]="getGypsumSheetsSize(rowData)"
                          >
                          <option value="2x10">2x10</option>
                          <option value="2x12">2x12</option>
                          <option value="4x8">4x8</option>
                          <option value="4x12">4x12</option>

                        </select>

                      </div>
                    </td>
                    <td data-title="Description">
                      {{ rowData.description }}
                    </td>
                    <td data-title="Manufacturer">
                      {{ rowData.manufacturer }}
                    </td>
                    <td data-title="Model">
                      {{ rowData.manufacturerModel }}
                    </td>
                    <td class="no-wrap" data-title="Quantity">
                      <div class="">
                        {{ rowData.modelQuantity }}
                        {{ rowData.modelQuantityDescription }}
                      </div>
                    </td>
                    <td class="no-wrap" data-title="Waste Factor">
                      <div class="">
                        {{ rowData.wasteFactor }}
                      </div>
                    </td>
                    <td class="no-wrap" data-title="Quantity to Order">
                      <div class="">
                        {{ rowData.quantityToOrder }}
                        {{ rowData.quantityToOrderDescription }}
                      </div>
                    </td>
                    <!-- New Cost Columns -->
                    <td   class="no-wrap" data-title="Unit price" *ngIf="data?.hasPrice">
                      {{ rowData.cost === 0 ? 'N/A' : (rowData.cost | currency) }}
                    </td>
                    <td class="no-wrap" data-title="Total price" *ngIf="data?.hasPrice">
                      {{ rowData.cost === 0 ? 'N/A' : (rowData.totalCost | currency) }}
                    </td>

                    <td class="small-spacing" >
                      <!-- If custom item -->
                      <button
                        class="delete-custom-item"
                        *ngIf="isBomTypeAddon(rowData) && !rowData.showLoader"
                        (click)="deleteCustomItem(rowData, subcategory)"
                      >
                        <img src="assets/img/recycle-bin.png" />
                      </button>

                      <!-- If LumberTotal or ChildTotalLumber: show "Configure Lumber" button -->
                      <button
                        *ngIf="isTotalLumber(rowData)"
                        class="btn border-0 small-spacing"
                        (click)="openLumberPopup(rowData)"
                         ngbTooltip="Settings"
                      >
                      <i class="bi bi-gear"></i>
                      </button>
                    </td>

                    <td class="small-spacing">
                      <!-- If Perent contains Childrens we can  remove all childrens -->
                      <button
                      *ngIf="isTotalLumberWithChildren(rowData)"
                        class="btn  border-0"  ngbTooltip="Reset"
                        (click)="resetTotalSettings(rowData)">
                          <i class="bi bi-slash-circle"></i>
                       </button>

                      <button
                      *ngIf="isChildTotalLumber(rowData)"
                      class="btn border-0"
                      (click)="deleteLumberItem(rowData)"
                       ngbTooltip="Remove row">



                        <i class="bi bi-trash"></i>
                      </button>
                    </td>

                  </ng-container>

                  <ng-container *ngIf="rowData.isEditMode">
                    <!-- Existing edit mode fields -->
                    <td class="text-center hidden-mobile" scope="row"></td>
                    <td data-title="Item">
                      <input
                        [myFocus]="true"
                        class="edit-custom-item"
                        [(ngModel)]="rowData.itemName"
                        placeholder="Enter"
                      />
                    </td>

                    <td data-title="Size">
                      <input
                        class="edit-custom-item"
                        [(ngModel)]="rowData.size"
                        placeholder="Enter"
                      />
                    </td>

                    <td data-title="Description">
                      <input
                        class="edit-custom-item"
                        [(ngModel)]="rowData.description"
                        placeholder="Enter"
                      />
                    </td>

                    <td data-title="Manufacturer">
                      <input
                        class="edit-custom-item"
                        [(ngModel)]="rowData.manufacturer"
                        placeholder="Enter"
                      />
                    </td>
                    <td data-title="Model">
                      <input
                        class="edit-custom-item"
                        [(ngModel)]="rowData.manufacturerModel"
                        placeholder="Enter"
                      />
                    </td>

                    <td data-title="Quantity">
                      <input
                        class="edit-custom-item"
                        [(ngModel)]="rowData.modelQuantity"
                        placeholder="Enter"
                      />
                    </td>

                    <td data-title="Waste Factor">
                      <input
                        class="edit-custom-item"
                        [(ngModel)]="rowData.wasteFactor"
                        placeholder="Enter"
                      />
                    </td>

                    <td data-title="Quantity to Order">
                      <input
                        class="edit-custom-item"
                        [(ngModel)]="rowData.quantityToOrder"
                        placeholder="Enter"
                      />
                    </td>
                    <td class="text-center" scope="row">
                      <div class="d-flex justify-content-end">
                        <button
                          (click)="saveCustomItem(rowData, subcategory)"
                          class="save-custom-line-button"
                        >
                          Save
                        </button>
                        <button
                          class="save-custom-line-button"
                          (click)="deleteCustomItem(rowData, subcategory)"
                        >
                          Cancel
                        </button>
                      </div>
                    </td>
                    <td></td>
                  </ng-container>
                </tr>
                <tr
                  *ngIf="!subcategory.name.toLowerCase().startsWith('total')"
                  class="add-custom-line"
                >
                  <td colspan="16">
                    <button
                      (click)="addCustomLine(subcategory)"
                      class="add-custom-line-button"
                    >
                      <img
                        class="btn-icon"
                        src="assets/img/plus.png"
                        alt="icon"
                      />Add Custom Line
                    </button>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="data && exportType && sortedCategories">
  <div class="selection-container">
    <div class="row justify-content-start">
      <div class="col-auto">
        <button class="btn btn-back" (click)="backToTable()">
          <div class="icon icon-left-arrow"></div>
          <span class="btn-text">Back</span>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="page-title">Download document</div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12">
        <app-export-list
          (export)="exportTo(exportType, $event); backToTable()"
          [defaultSelectAll]="true"
          [items]="sortedCategories"
        />
      </div>
    </div>
  </div>
</ng-container>

<!-- Simple inline popup for lumber configuration -->
<!-- The popup container -->
<div class="lumber-popup-backdrop" [class.show]="selectedItemForPopup">
  <div class="lumber-popup">
    <div class="lumber-popup-header">
    <h3>Lumber Configuration</h3>
  </div>

    <!-- Length Selection -->
    <div class="form-group">
      <label>Length (ft):</label>
      <!-- Slider control (8 to 20 ft, step 2) -->
      <div class="range-slider__range d-flex align-items-center">
        <!-- Slider control (8 to 24 ft, step 2) -->
        <input
          type="range"
          min="8"
          max="24"
          [defaultValue]="8"
          step="2"
          [(ngModel)]="lumberLength"
          (input)="recalculateLumber()"
        />
        <!-- Disabled input to display the length -->
        <span class="range-slider__value">{{lumberLength}}</span>
      </div>
    </div>
    <div class="separator"></div>
    <div style="display: flex; flex-direction: row; justify-content: space-between; gap: 20px; margin-top: 20px;">
      <!-- Quantity input -->
      <div class="form-group">
        <label>Quantity:</label>
        <input
          id="qtyInput"
          type="number"
          class="form-control"
          (input)="onLengthInputChange()"
          [(ngModel)]="lumberQuantity"
          placeholder="Enter quantity"
        />
      </div>

      <!-- Total length display -->
      <div class="form-group" *ngIf="lumberLength && lumberQuantity">
        <label>Total length:</label>
        <input
          type="text"
          class="form-control"
          [value]="lumberQuantity * lumberLength + ' ft'"
          readonly
        />
      </div>
    </div>

      <!-- Warning message -->
      <div style="min-height: 30px;">
        <div *ngIf="isSetDisabled" class="text-warning mt-1">
            {{ quantityWarningMessage }}
        </div>
      </div>



    <div class="d-flex justify-content-center mt-3">
      <button class="btn btn-secondary me-2 flex-fill" (click)="closeLumberPopup()">Close</button>
      <button class="btn btn-primary  flex-fill" (click)="calculateLumber()" [disabled]="isSetDisabled">Set</button>
    </div>
  </div>
</div>
